export type BrowserStorageAppKey =
  | "airange-admin"
  | "redblue-admin"
  | "micro-lab-admin"
  | "ctf-admin";

export type BrowserStoragePurpose = "chunkReloadOnce";

const BROWSER_STORAGE_PREFIX = "airange";
const CHUNK_RELOAD_ONCE_VALUE = "1";

type ChunkLoadErrorReason = {
  message?: unknown;
  name?: unknown;
};

export function buildAirangeBrowserStorageKey(
  appKey: BrowserStorageAppKey,
  purpose: BrowserStoragePurpose,
): string {
  return `${BROWSER_STORAGE_PREFIX}.${appKey}.${purpose}`;
}

export function buildChunkReloadStorageKey(appKey: BrowserStorageAppKey): string {
  return buildAirangeBrowserStorageKey(appKey, "chunkReloadOnce");
}

export function isChunkLoadErrorReason(reason: unknown): boolean {
  const errorReason = reason as ChunkLoadErrorReason | undefined;
  const message = String(errorReason?.message || "");
  const name = String(errorReason?.name || "");
  return name.includes("ChunkLoadError")
    || message.includes("Loading chunk")
    || message.includes(".async.js");
}

export function reloadOnceForChunkLoadError(
  appKey: BrowserStorageAppKey,
  win: Window = window,
): boolean {
  const storageKey = buildChunkReloadStorageKey(appKey);
  if (win.sessionStorage.getItem(storageKey) === CHUNK_RELOAD_ONCE_VALUE) {
    return false;
  }
  win.sessionStorage.setItem(storageKey, CHUNK_RELOAD_ONCE_VALUE);
  win.location.reload();
  return true;
}

export function registerChunkLoadErrorReloadOnce(
  appKey: BrowserStorageAppKey,
  win: Window | undefined = typeof window !== "undefined" ? window : undefined,
): void {
  if (!win) return;
  win.addEventListener("unhandledrejection", (event) => {
    if (!isChunkLoadErrorReason(event.reason)) return;
    reloadOnceForChunkLoadError(appKey, win);
  });
}
